<template>
  <b-container fluid class="holder h-100">
    <div  class="container-fluid fill p-0">
        <div class="w-100 h-100 d-flex align-items-center justify-content-center" v-if="!component.orderId"><b-spinner /></div>
    <div v-else>
    <b-row class="bg-white top-bar d-flex align-items-center justify-content-between fill border-bottom">
        <b-col class="d-flex align-items-center px-0">
        <h4 class="m-0 pl-3">Order {{ component.orderId }} &ndash; ${{ component.orderTotal }}</h4>
        </b-col>
        <b-col class="d-flex justify-content-center">
            {{ moment(component.platform.date || component.createdAt).format('M/D/YYYY h:mma') }}
            <span v-if="printed" class="printedIcon ml-3" id="printOrder"><b-icon-printer></b-icon-printer>
                <b-tooltip target="printOrder" triggers="hover" placement="bottom">
                <span>Printed <span v-if="component.printing[0].username"> by <strong>{{ component.printing[0].username }}</strong></span> on <strong>{{moment(component.printing[0].date).format('M/D/YYYY h:mma')}}</strong> </span>
            </b-tooltip>
        </span>
        </b-col>
        <b-col class="d-flex justify-content-end">
            <b-button-toolbar>
            <b-button variant="outline-secondary"  v-b-tooltip.hover.bottom="'Preview Invoice'" class="shadowNone mr-3" id="previewInvoice" @click="previewInvoice()"><b-icon-envelope></b-icon-envelope></b-button>
            <b-button variant="outline-secondary"  v-b-tooltip.hover.bottom="'Send Invoice'" class="shadowNone mr-3" id="sendInvoice" @click="sendInvoice()"><b-icon-receipt></b-icon-receipt></b-button>
            <b-button variant="outline-secondary"  class="shadowNone mr-3" id="printOrder" @click="printOrder()"><b-icon-printer></b-icon-printer></b-button>
            <order-location :location="component.location" @update="update('location', $event )" @promptRefundIfNeeded="maybeShowRefundModal"></order-location>
            </b-button-toolbar>
      </b-col>
    </b-row>
    <b-container class="flex-grow-1 overflow-auto order-content" fluid v-if="orderFetched">
                <b-row class="d-flex">
                    <b-col class="order-col">
                        <customer
                            :customer="component.customer"
                            :printView="printView"
                            :recentlySaved="recentlySaved"
                            @update="update('customer', $event)"
                            @phone-blur="handlePhoneBlur"
                            @tax-id-blur="handleTaxIdBlur"
                        ></customer>
                        <payment-list
                            :email="component.customer.email"
                            :platform="component.platform"
                            :payments="component.payment"
                            :refunds="component.refunds"
                            :order-id="component.orderId || component.id"
                            :order="component"
                            :printView="printView"
                            class="mt-5"
                            @update="update('payment', $event)"
                            @refunds-updated="update('refunds', $event)"
                        ></payment-list>

                        <refund-list :refunds="component.refunds" :printView="printView" class="mt-5" @update="update('refunds', $event)"></refund-list>
                    </b-col>

                    <b-col class="order-col">
                        <platform :platform="component.platform" :printView="printView" :location="component.location" @update="update('platform', $event)"></platform>

                        <shipping :shipping="component.shipping" :printView="printView" :shippingTotal="component.shippingTotal" :orderId="component.orderId" :delivery="component.delivery" class="mt-4" @update="update('shipping', $event)"></shipping>

                        <div class="flags-section my-3">
                            <h5 class="text-secondary mb-2">Flags</h5>
                            <b-form-group class="mb-0">
                                <b-row no-gutters class="align-items-center">
                                    <b-col cols="auto">
                                        <b-form-checkbox v-model="component.phoneRequired" class="text-nowrap mr-4 mb-0">
                                            Phone Required
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b-form-checkbox v-model="component.latinTaxId" class="text-nowrap mr-4 mb-0">
                                            Latin Tax ID
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b-form-checkbox v-model="component.uncombined" class="text-nowrap mr-4 mb-0">
                                            Uncombined
                                        </b-form-checkbox>
                                    </b-col>
                                    <b-col cols="auto">
                                        <b-form-checkbox v-model="component.zeroQtyItems" class="text-nowrap mr-4 mb-0">
                                            0 Qty Items
                                        </b-form-checkbox>
                                    </b-col>
                                    
                                    <b-col cols="auto" class="d-flex align-items-center">
                                        <b-form-checkbox v-model="component.customFlag" class="mb-0 mr-2">
                                            <span v-if="!component.customFlag" class="text-nowrap">Custom Flag</span>
                                            <b-form-input
                                                v-else
                                                v-model="component.customFlagText"
                                                size="sm"
                                                class="custom-flag-input"
                                                placeholder="Enter custom flag text"
                                            ></b-form-input>
                                        </b-form-checkbox>
                                    </b-col>
                                </b-row>
                            </b-form-group>
                        </div>

                        <note-list :notes="component.notes && component.notes.length > component.notes.length ? component.notes : component.notes || []" :printView="printView" class="mt-4" @update="update('notes', $event)" :newlyCancelled="false"></note-list>

                        <discount-list :discounts="component.discounts || []" :printView="printView" @update="update('discounts', $event)" class="mt-4"></discount-list>
                    </b-col>
                </b-row>

                <b-row class="mt-5">
                    <b-col class="header-menu-text">
                        <h5 class="text-secondary">{{ numOrderItems }} {{ numOrderItems === 1 ? 'Item' : 'Items' }} - ${{ orderItemTotal }}</h5>
                    </b-col>
                </b-row>

                <div>
                    <b-overlay :show="isSearching" variant="light" opacity="0.4">
                    <b-form-input :disabled="this.disableItemSearch || component.location === 'Cancelled'" :state="addItemState" size="sm" class="mb-3" :placeholder="searchPlaceholder" v-model="itemSearch" v-on:keyup.enter="addItem"></b-form-input>
                    <b-form-invalid-feedback id="input-live-feedback">
                        {{ addItemStateText }}
                    </b-form-invalid-feedback>
                    </b-overlay>
                </div>

                <b-list-group
                        v-for="(item, index) in component.items"
                        v-bind:key="'orderitem-' + index">
                        
                    <b-row class="order-item-row">
                       
                        <b-col class="py-3">
                            <item :item="item.details" :status="item.status || null" :printView="false"></item>
                        </b-col>

                        <b-col sm="1" class="text-right">
                            <b-dropdown :disabled="item.status && (item.status.type === 'removed' || item.status.type === 'cancelled')" ref="removeItemDropdown" no-caret size="sm" variant="link" class="menu-btn" toggle-class="text-decoration-none" right>
                                <template #button-content>
                                    <b-button variant="outline-secondary" size="sm">
                                        <b-icon-x></b-icon-x>
                                    </b-button>
                                </template>
                                <remove-item :item="item" :orderId="component.orderId" @removeItem="removeOrderItem($event)"></remove-item>
                            </b-dropdown>
                        </b-col>
                    </b-row>

                </b-list-group>
            </b-container>
        </div>
        </div>
        <div class="bottomBar">
            <b-button class="mx-4" size="sm" :variant="hasChanges ? 'dark' : 'secondary'" @click="close">
                Close
            </b-button>
            <b-button class="saveButton" size="sm" :variant="saveButtonVariant" @click="saveOrder"><span v-if="saving"><b-spinner small /></span><span v-else>{{recentlySaved ? 'Saved!' : 'Save Changes'}}</span></b-button>
        </div>
        <cancellation-modal :orderId="component.orderId" :itemsOnOrder="component.items" :existingNotes="component.notes && component.notes.length > 0 ? component.notes : component.notes" :newlyCancelled="isCancelled" @updateNotes="update('notes', $event)" @saveOrder="saveOrder" />

        <b-modal v-model="showRefundModal" title="Add Refund" hide-footer size="md" body-class="pb-4" @hidden="showRefundModal = false">
            <refund standalone @addRefund="onRefundModalAdd($event)" />
        </b-modal>

        <b-modal id="addItemModal"
                    size="lg"
                    scrollable
                    hide-footer
                    button-size="sm"
                    centered>

              <template #modal-header>
                  <h4>Search results</h4>
              </template>

              <b-list-group>
                  <b-list-group-item v-for="(item, index) in potentialItems" :key="index">
                      <edit-order-item :editing='editingItem' :orderId='component.orderId' :existingOrderQuantity='itemQuantityOnOrder(item)' :orderItems='component.items' :item="item" @addOrderItem="$event => addOrderItem($event)" @toggleEditing="toggleEditingItem"></edit-order-item>
                      <b-list-group-item v-if="item.listing.offsite" variant="warning" size="sm" class="mt-3">This item can't be added because it is off-site.</b-list-group-item>
                  </b-list-group-item>
              </b-list-group>
          </b-modal>
 </b-container>
</template>

<script>

import Platform from "./Platform";
    import NoteList from "./NoteList";
    import PaymentList from "./PaymentList";
    import RefundList from "./RefundList";
    import Refund from "./Refund";
    import Shipping from "./Shipping";
    import Customer from "./Customer";
    import utils from "../../mixins/utils";
    import CancellationModal from "./CancellationModal";
    import EditOrderItem from "./EditOrderItem";
    import Item from './Item';
    import RemoveItem from "./RemoveItem";
    import DiscountList from "./DiscountList";
    import ordersApi from "../../api/orders";
    import inventoryApi from "../../api/inventory";
    import ObjectMixin from "../../mixins/object";
    import OrderLocation from "./OrderLocation";
    import { isEmpty } from "lodash";
    import freeShippingPlatformList from "../../assets/freeShippingPlatformList";


export default {
        name: "OrderForm",
        components: { Customer, Shipping, Platform, NoteList, PaymentList, RefundList, Refund, Item, RemoveItem, DiscountList, OrderLocation, CancellationModal, EditOrderItem },
        mixins: [ ordersApi, inventoryApi, ObjectMixin, freeShippingPlatformList, utils ],
        props: [ 'orderId', 'printView', 'updated', 'disableItemSearch'],
        async beforeMount() {
          this.component = {};
        },
        beforeDestroy() {
            // clean up values and event listeners
            this.component = {};
            this.originalOrder = {};
            this.hasChanges = false;
            window.removeEventListener('keyup', this.onKeyUp);
            window.removeEventListener('keydown', this.onKeyDown);
        },
        async mounted() {
          window.addEventListener('keyup', this.onKeyUp);
          window.addEventListener('keydown', this.onKeyDown);
          this.component = {}
          this.orderLoading = true;
          const order = await this.getOrder(this.orderId);
          if (order) {
            const deeplyClonedCopy = this.deepClone(order);
            order && this.clone(deeplyClonedCopy);

            const flags = deeplyClonedCopy.flags || {};
            // map persisted flags to editable UI fields
            this.$set(this.component, 'phoneRequired', !!flags.noPhone);
            this.$set(this.component, 'latinTaxId', !!flags.noLatinTaxId);
            this.$set(this.component, 'uncombined', !!flags.unmerged);
            this.$set(this.component, 'zeroQtyItems', !!flags.zeroQtyItems);
            this.$set(this.component, 'customFlag', !!flags.other);
            this.$set(this.component, 'customFlagText', flags.other || '');

            deeplyClonedCopy.phoneRequired = !!flags.noPhone;
            deeplyClonedCopy.latinTaxId = !!flags.noLatinTaxId;
            deeplyClonedCopy.uncombined = !!flags.unmerged;
            deeplyClonedCopy.zeroQtyItems = !!flags.zeroQtyItems;
            deeplyClonedCopy.customFlag = !!flags.other;
            deeplyClonedCopy.customFlagText = flags.other || '';

            this.originalOrder = deeplyClonedCopy;
            this.orderFetched = true;
          }
          this.orderLoading = false;
          this.hasChanges = false;
        },
        deactivated() {
            window.removeEventListener('keyup', this.onKeyUp);
            window.removeEventListener('keydown', this.onKeyDown);
        },
        activated() {
            window.addEventListener('keyup', this.onKeyUp);
            window.addEventListener('keydown', this.onKeyDown);
        },
        watch: {
        'component': {
          handler: 'checkChanges',
          deep: true,
        },
        // watch for changes in component.shipping.method and update totals
        'component.shipping.method': {
          handler: 'updateTotals',
          deep: true,
        },
        // watch for changes in component.items and update totals
        'component.items': {
          handler: 'updateTotals',
          deep: true,
        },
        // watch for changes in component.discounts and update totals
        'component.discounts': {
          handler: 'updateTotals',
          deep: true,
        },
      },
        data() {
          return {
            orderLoading: false,
            hasChanges: false,
            orderFetched: false,
            itemSearch: null,
            addItemState: null,
            addItemStateText: 'No item found.',
            potentialItems: [],
            isSearching: false,
            editingItem: false,
            component: {},
            originalOrder: {},
            saving: false,
            recentlySaved: false,
            showRefundModal: false,
          }
        },
        methods: {
          handlePhoneBlur(hasPhone) {
            if (hasPhone) {
              this.$set(this.component, 'phoneRequired', false);
            }
          },
          handleTaxIdBlur(hasTaxId) {
            if (hasTaxId) {
              this.$set(this.component, 'latinTaxId', false);
            }
          },
          maybeShowRefundModal() {
            if (!this.component.refunds || this.component.refunds.length === 0) {
              this.showRefundModal = true;
            }
          },
          onRefundModalAdd(refund) {
            this.update('refunds', [...(this.component.refunds || []), refund]);
            this.showRefundModal = false;
          },
          close() {
            if (this.hasChanges) {
                if (window.confirm('You have unsaved changes. Are you sure you want to close?')) {
                this.orderFetched = false;
                this.component = {};
                this.$emit("closeOrder");
                }
            } else {
                this.orderFetched = false;
                this.component = {};
                this.$emit("closeOrder");
            }
          },
          onKeyUp(event) {
            if (event.key === 'Escape' || event.keyCode === 27) {
                this.close();
            }
          },
          onKeyDown(event) {
            // Check if Cmd or Ctrl key is pressed along with 'S'
                if ((event.metaKey || event.ctrlKey) && event.key === 's') {
                    event.preventDefault(); // Prevent browser's default action
                    this.saveOrder();
                }
            },
          update(key, updatedValue) {
            if (key === 'customer') {
                updatedValue = { ...updatedValue, address: { ...updatedValue.address } };
            }
            this.$set(this.component, key, updatedValue);
          },
          checkChanges() {
            this.hasChanges = !this.isEqual(this.component, this.originalOrder) && !this.orderLoading && Object.keys(this.originalOrder).length > 0;
          },
          async updateTotals() {
              const itemTotal = this.orderItemTotal;
              let shippingOptions = this.component.items && this.component.items.length > 0 ? await this.getShippingOptions(this.component.items) : {};
              let shippingTotal = this.component.shipping && this.component.shipping.method && this.component.shipping.method !== 'Local Pickup' && itemTotal > 0 ? shippingOptions[this.component.shipping.method].cost : 0;
              if (this.component.shipping) {
                  this.$set(this.component.shipping, 'cost', shippingTotal);
              }
              if (this.component.shipping && this.component.shipping.method && this.component.shipping.method !== 'Local Pickup' && !this.hasFreeShipping) {
                  this.$set(this.component, 'shippingTotal', shippingTotal);
              } else {
                  this.$set(this.component, 'shippingTotal', 0);
                  shippingTotal = 0;
              }
              let newTotal = itemTotal + shippingTotal;
              let discounts = 0;
              if (this.component.discounts && this.component.discounts.length > 0 ) {
                  this.component.discounts.forEach(discount => discounts += Number(discount.amount));
              }
              this.$set(this.component, 'itemTotal', itemTotal);
              this.$set(this.component, 'orderTotal', newTotal - discounts);
          },
          async previewInvoice() {
              try {
                  await this.emailPreviewInvoice(this.orderId);
                  this.showToast('Invoice Preview', 'Sent to your email.');
              } catch (err) {
                  this.showError(err, 'Invoice Preview');
              }
          },
          async sendInvoice() {
              try {
                  await this.emailInvoice(this.orderId);
                  this.showToast('Invoice Sent', 'Success!');
              } catch (err) {
                  this.showError(err, 'Invoice');
              }
          },
          async printOrder() {
            let data = this.deepClone(this.component);
            this.$emit('printOrder', data);
          },
          async saveOrder() {
            this.saving = true;
            try {
                // create data object to send to api without _v and _id in this.component
                let data = this.deepClone(this.component);

                // map UI flag fields into persisted order.flags
                if (!data.flags) {
                    data.flags = {};
                }
                data.flags.noPhone = !!data.phoneRequired;
                data.flags.noLatinTaxId = !!data.latinTaxId;
                data.flags.unmerged = !!data.uncombined;
                data.flags.zeroQtyItems = !!data.zeroQtyItems;
                data.flags.other = data.customFlag ? (data.customFlagText || '') : '';

                // delete transient UI-only flag helpers from payload
                delete data.phoneRequired;
                delete data.latinTaxId;
                delete data.uncombined;
                delete data.zeroQtyItems;
                delete data.customFlag;
                delete data.customFlagText;

                // delete __v and _id from data
                delete data.__v;
                delete data._id;
                await this.updateOrder(this.component.orderId, data);
                this.recentlySaved = true;
                setTimeout(() => {
                  this.recentlySaved = false;
                }, 2000);
            } catch (error) {
                this.showError(error, 'Order Error');
                this.saving = false;
            } finally {
                // keep originalOrder in sync, including UI helper fields, for change detection
                this.originalOrder = this.deepClone(this.component);
                this.checkChanges();
                this.saving = false;
            }
          },
          getActiveListings(item) {
                let newItems = [];

                item.listing.forEach(listing => {
                    if (listing.type === 'active' && listing.count > 0) {
                        let newItem = {...item};
                        newItem.listing = listing;
                        newItems.push(newItem);
                    }
                });

                return newItems;
          },
          async addItem() {
                this.addItemState = null;
                this.addItemStateText = '';
                this.potentialItems = [];
                this.isSearching = true;

                if (!isNaN(this.itemSearch)) {
                    try {
                        const item = await this.getItem(this.itemSearch);
                        
                        let actives = this.getActiveListings(item);

                        if (actives.length > 0) {
                            actives.forEach(newItem => {
                                newItem.quantity = 1;

                                this.potentialItems.push(newItem);
                            });

                            this.$bvModal.show('addItemModal');
                        } else {
                            this.addItemState = false;
                            this.addItemStateText = 'Item not in stock.';
                        }

                        this.isSearching = false;
                    } catch(err) {
                        if (err.response && err.response.status && err.response.status === 404) {
                            this.addItemState = false;
                            this.addItemStateText = 'Item does not exist.';
                        }

                        this.isSearching = false;
                    }

                } else {
                    try {
                        let results = await this.getItems({ q: this.itemSearch });
                        results.docs.forEach(item => {
                            if (item.listing.type === 'active' && item.listing.count > 0 && this.itemNotOnOrder(item)) {
                                item.quantity = 1;

                                this.potentialItems.push(item);
                            }
                        });

                        if (!this.potentialItems.length) {
                            this.addItemState = false;
                            this.addItemStateText = 'No items found.';
                        } else {
                            this.$bvModal.show('addItemModal');
                        }

                        this.isSearching = false;
                    } catch (err) {
                        this.addItemState = false;
                        this.addItemStateText = 'No items found.';

                        this.isSearching = false;
                    }
                }
                // if a number, and doesn't have an underscore assume it's the first active listing
            },
            itemNotOnOrder(item) {
                let notOnOrder = true;

                if (this.component.items.length > 0) { this.component.items.forEach(i => {
                    if ((i.status && i.status.type === 'removed') && i.details.listing._id === item.listing._id) {
                        notOnOrder = false;
                    }
                }); }

                return notOnOrder;
            },
            itemQuantityOnOrder(potentialItem) {
                if (this.component.items && this.component.items.length > 0) {
                    let itemOnOrder = this.component.items.filter((i) => {
                        return i.details.listing._id === potentialItem.listing._id  
                    });
                    if (itemOnOrder.length > 0 && itemOnOrder[0].details.quantity > 0) {
                        if (itemOnOrder[0].status && (itemOnOrder[0].status.type === "removed" || "cancelled")) return 0
                        return itemOnOrder[0].details.quantity
                    }
                    return 0;
                }
                return 0; 
            },
            toggleEditingItem() {
                this.editingItem = !this.editingItem;
            },
            async addItemToOrder(updatedItem) {
                if (!this.detailsOrder.items) {
                    this.detailsOrder.items = [];
                }
                let updatedArray = [...this.detailsOrder.items];
                const alreadyAdded = this.detailsOrder.items && this.detailsOrder.items.length > 0 && this.detailsOrder.items.some(item => item.details && item.details.listing._id === updatedItem.details.listing._id);
                if (alreadyAdded) {
                    updatedArray = this.detailsOrder.items.map((item)=> {return item.details.listing._id === updatedItem.details.listing._id ? updatedItem : item})
                } else {
                    updatedArray.push(updatedItem);
                }
                this.$set(this.detailsOrder, 'items', updatedArray);
                this.updateTotals(this.detailsOrder.items);
            },
            
            async addOrderItem(updatedItem) {
              if (!this.component.items) {
                    this.component.items = [];
                }
                let updatedArray = [...this.component.items];
                const alreadyAdded = this.component.items && this.component.items.length > 0 && this.component.items.some(item => item.details && item.details.listing._id === updatedItem.details.listing._id);
                if (alreadyAdded) {
                    updatedArray = this.component.items.map((item)=> {return item.details.listing._id === updatedItem.details.listing._id ? updatedItem : item})
                } else {
                    updatedArray.push(updatedItem);
                }
                this.$set(this.component, 'items', updatedArray);
                this.$set(this.originalOrder, 'items', updatedArray);
                this.editingItem = false;
                this.$bvModal.hide('addItemModal');
            },

            async removeOrderItem(updatedItem) {
              const updatedArray = this.component.items.map((item)=> {return item.details.listing._id === updatedItem.details.listing._id ? updatedItem : item})
              this.$set(this.component, 'items', updatedArray);
            },
        },
        computed: {
          numOrderItems() {
                let count = 0;
                if (this.component.items && this.component.items.length > 0) {
                    this.component.items.forEach(item => {
                        if (!item.status || item.status.type !== 'removed') {
                            count += parseInt(item.details.quantity);
                        }
                    });
                }
                return count;
          },
          orderItemTotal() {
              let total = 0;
              if (this.component.items && this.component.items.length > 0) {
                  this.component.items.forEach(item => {
                      if (!item.status || item.status.type !== 'removed') {
                          total += parseFloat(item.details.listing.price * item.details.quantity);
                      }
                  });
              }
              return total;
          },
          orderDiscountTotal() {
            let total = 0;
            this.component.discounts && this.component.discounts.length > 0 && this.component.discounts.forEach(item => {
                total += parseFloat(item.amount)
            });
            return total;
          },
          searchPlaceholder() {
            if (this.disableItemSearch) {
                return "Save previously cancelled order to add items..."
            } else if (this.component.location && this.component.location === "Cancelled") {
                return "Cannot add items to a cancelled order..."
            } else {
                return "Add item by entering SKU or search text..."
            }
          },
          saveButtonVariant() {
            if (this.recentlySaved) {
                return 'primary';
            } else if (this.hasChanges) {
                return 'success';
            } else {
                return 'secondary';
            }
          },
          printed() {
            return this.component.printing && this.component.printing.length > 0;
          },
          hasFreeShipping() {
            if (this.component && this.component.shipping && this.component.shipping.method && this.component.shipping.method === 'Local Pickup') return true;
            if (isEmpty(this.component) || this.component.platform?.site == null) return false;
            const platformQualifies = this.component.platform.site && this.freeShippingPlatformList.includes(this.component.platform.site);
            return platformQualifies && this.component.itemTotal > 99 && this.component.shipping && this.component.shipping.method && this.component.shipping.method === 'Media Mail' && this.component.customer && this.component.customer.address && this.component.customer.address.country && this.component.customer.address.country === 'US';
          },
          isCancelled() {
            if (this.component.location) {
                return this.component.location && this.component.location === "Cancelled" && this.originalOrder.location !== "Cancelled";
            } else {
                return false;
            } 
          }, 
        }

      }
</script>


<style scoped>


  .order-col {
    max-width: 680px;
  }

  .saveButton {
    width: 110px;
  }

  .top-bar {
    z-index: 4;
    position: fixed;
    top: 40px;
    width: 100%;
    padding-top: 20px;
    padding-bottom: 10px;
    padding-right: 30px;
    padding-left: 10px;
  }
  .bottomBar {
    z-index: 100;
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 60px;
    background-color: rgba(173, 171, 171, 0.291);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 40px;
    backdrop-filter: blur(20px);
  }

  .order-content {
    padding-top: 60px;
    padding-bottom: 90px;
    max-height: calc(100vh - 100px);
  }

  .scroller {
    overflow-y: auto;
  }

  .order-item-row {
    max-width: 1200px;
  }

  
  .shadowNone.btn-outline-secondary:active,
  .shadowNone.btn-outline-secondary:focus,
  .shadowNone.btn-outline-secondary.active,
  .shadowNone.btn-outline-secondary:active:focus {
    background-image: none;
    outline: 0;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
  }

  .flags-section .custom-flag-input {
    max-width: 200px;
  }
</style>
